import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { NavigationExtras, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { APIService } from '../api.service';
import { DataService } from '../services/data.service';
import * as xlsx from 'xlsx';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VoucherEntryComponent } from '../voucher-entry/voucher-entry.component';
import { MatSort } from '@angular/material/sort';
import { map, startWith } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { FinancialYearcountComponent } from '../financial-yearcount/financial-yearcount.component';
import { CommonService } from '../services/common.service';
import { toNumber } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { InvoiceStatusComponent } from  '../invoice-status/invoice-status.component'

export enum KEY_CODE {
  UP_ARROW = 38,
  DOWN_ARROW = 40,
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  ALT = 18,
  CTRL = 17,
  S = 83,
}

@Component({
  selector: 'app-ledgers',
  templateUrl: './ledgers.component.html',
  styleUrls: ['./ledgers.component.scss'],
})

export class LedgersComponent implements OnInit {
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  profitAndLossParameters: any = [];
  BindRecordLeft: any = [];
  BindRecordRight: any = [];

  ledgerid: any;
  modalReference: any;
  closeResult: string = '';
  ledgername: any;
  ledgerType: any;

  opbal: any;
  colbal: any;
  newcolbal1: any;
  newcolbal: any;
  newopbal: any;
  period: any;
  vouchernote: any;
  vouchernum: any;
  DateNote: any;
  vouchdate: any;

  ledger: any = [];
  ledgerList: any = [];
  templedgerList: any = [];
  agencyData: any = [];
  jarvisData: any = [];
  userList: any = [];
  data: any = [];
  voucher: any = [];
  ledgers: any = [];
  selectedFY: any;
  financialYears: any = [];
  ERP_Agn: Array<any> = [];
  Date: Array<any> = [];
  acctStartDT: Date = new Date();
  fromDate: any = new Date('2021-Apr-01');
  toDate: any = new Date('2022-Mar-31');
  exportToExcel: any = [];
  isAdmin: boolean = false;
  ledgerId:any;
  usersAllAcctRights: boolean = false;
  acctReportsOnly: boolean = false;
  ownUserRights: Array<any> = [];
  relID: number = 0;
  ldgrRcrdPrtPrefs: any = {
    isNarrrationEnbl: false,
    isCommonNotesEnbl: false
  };

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()

  dataSource = new MatTableDataSource();
  //dataSource: any = [];
  filteredOptions: Observable<string[]> | undefined;
  @ViewChild('LRTable', { static: false }) LRTable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('ldgrRcrdPrntPrefsMdl') ldgrRcrdPrntPrefsMdl!: ElementRef;

  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();
  show: any = {
    edit: true,
    save: false
  };
  disable: any = {
    fromInput: true,
    toInput: true
  };

  myControl = new FormControl();
  LedgerNameFilter = new FormControl();

  filterValues = {
    LedgerName: '',
    ItemCode: '',
    Category: '',
    CurrQty: '',
    SKU: '',
    StockValue: '',
    DefStockRate: '',
  };

  displayedColumns: string[] = [
    'date',
    'VoucherNum',
    'MainLedger',
    'DbAmt',
    'CrAmt',
    'CloBal',
    'Notes',
    'Print',
  ];

  erpConfig: any = [];

  constructor(
    private router: Router,
    private appService: DataService,
    private apiService: APIService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private commonSer: CommonService,
    private SpinnerLoader: NgxSpinnerService,
    private dateAdapter: DateAdapter<Date>,
  ) { this.dateAdapter.setLocale('en-IN') }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    
    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    if(this.userList.length > 0){
      let myUserData: Array<any> = this.userList.filter((x: any) => x.UserID == this.jarvisData[0].UserID);
      if(myUserData.length > 0){
        this.ownUserRights = myUserData;
        this.acctReportsOnly = this.ownUserRights[0].Accts;
        if(this.ownUserRights[0].AcctsVchrEntry == true && this.ownUserRights[0].AcctsCfg == true && this.ownUserRights[0].Accts == true){
            this.usersAllAcctRights = true;
        }
      }
    }

    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
      this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }

    this.LedgerNameFilter.valueChanges.subscribe((NameFilter) => {
      this.filterValues.LedgerName = NameFilter;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
    this.period = localStorage.getItem('periods');
    this.templedgerList = this.apiService.getCookie('Ledger');

    if(this.templedgerList){
      this.ledgerList = JSON.parse(this.templedgerList);
    }
    else {
      this.ledgerList = [];
    }

    // Get Id From Head Recorde Data
    if (this.commonSer.GetParam('lid')) {
      this.ledger.id = decodeURIComponent(this.commonSer.GetParam('lid') + '');
    } else {
      this.ledger.id = localStorage.getItem('ledgerid');
    }

    if (this.ledgerList.length > 0) {
      var templedgerlist = this.ledgerList.filter(
        (element: any, index: any) => {
          return element.LedgerID == this.ledger.id;
        }
      );
      if(templedgerlist.length > 0){
        this.ledgername = templedgerlist[0].LedgerName;
        this.ledgerType = templedgerlist[0].LedgerType;
        this.updateDisplayedColumns(templedgerlist[0].LedgerType);
      }
    }

    let tmpERP_Agn = this.apiService.getCookie('ERP_Agn');
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    //Get Account Start DT
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }

    // this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    // this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;

    // let date = this.apiService.getCookie("AccountsDates");
    // if (date) {
    //   this.Date = JSON.parse(date);
    //   this.getFromToDate();
    //   this.getData();
    // }
    // else {
    //   this.ddlchangeYear();
    // }

    this.financialYears = this.commonService.checkFinancialYear(
      this.acctStartDT,
      new Date());

    let fromDT = this.commonSer.GetParam('fromDT');
    let toDT = this.commonSer.GetParam('toDT');

    if(fromDT && toDT) {
      fromDT = String(fromDT);
      toDT = String(toDT);

      this.fromDate = new Date(decodeURIComponent(fromDT));
      this.toDate = new Date(decodeURIComponent(toDT));

      const currFY = this.commonService.checkFinancialYear(this.fromDate, this.toDate);
      let fdt = fromDT.split('-')[0] + '-' + fromDT.split('-')[1];
      let tdt = toDT.split('-')[0] + '-' + toDT.split('-')[1];
      
      if(currFY.length > 1 || fdt != '01-Apr' || tdt != '31-Mar') {
        this.selectedFY = 'Other';
      } else {
        this.selectedFY = this.fromDate.getFullYear() + '-' + this.toDate.getFullYear();
      }
    } else {
      this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
      let currentDate = new Date();
      this.fn_Set_FinancialYear(currentDate);
    }

    // let accountsDate: any = this.apiService.getCookie('AccountsDates');
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //     this.toDate = new Date(accountsDate[0].tdt);
    //     // this.toDate=this.toDate.replace(/%20/g, " ");
    //     this.fromDate = new Date(accountsDate[0].fdt);
    //     //this.fn_ChangeDate();

    //     if (this.selectedFY != 'Other') {
    //       let selectedYear = this.selectedFY.split('-');
    //       let accountDate: Array<any> = [
    //         {
    //           fdt: '1-Apr-' + selectedYear[0],
    //           tdt: '31-Mar-' + selectedYear[1],
    //           selectedFy: this.selectedFY,
    //         },
    //       ];
    //       this.apiService.setCookie(
    //         'AccountsDates',
    //         JSON.stringify(accountDate)
    //       );
    //     }
    //   } else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //     let currentDate = new Date();
    //     this.fn_Set_FinancialYear(currentDate);
    //   }
    // } else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   let currentDate = new Date();
    //   this.fn_Set_FinancialYear(currentDate);
    // }

    //this.dataSource.sort = this.sort;

    // this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());

    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //   }
    //   else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   }
    // }
    // else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    // }

    this.getData();
  }

  getFromToDate() {
    this.fromDate = new Date(this.Date[0].fdt);
    this.toDate = new Date(this.Date[0].tdt);
  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      //let selectedYear;
      //selectedYear = this.selectedFY.split('-');
      //let toDate = Number(selectedYear) + 1 + '/03/31';
      //this.selectedDate = toDate;
      let selectedYear = String(this.selectedFY).split("-");
      // let toDate = Number(selectedYear) + 1 + '/03/31';
      let accountDate: Array<any> = [{
        fdt: '1-Apr-' + selectedYear[0],
        tdt: '31-Mar-' + selectedYear[1],
        selectedFy: this.selectedFY
      }];
      // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));

      this.fromDate = new Date(accountDate[0].fdt);
      this.toDate = new Date(accountDate[0].tdt);
      this.getData();
     // this.fn_Set_FinancialYear(toDate);
    }
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1;
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1;
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + '/04/01');
      this.toDate = new Date(Date1.getFullYear() + '/03/31');
    } else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + '/04/01');
      this.toDate = new Date(Year + '/03/31');
    }
    this.getData();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == KEY_CODE.CTRL + KEY_CODE.S) {
      // Your row selection code
    }
  }

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getData() {
    if(this.ledgerId){
      this.ledger.id=this.ledgerId;
    }else{
      if (this.commonSer.GetParam('lid')) {
        this.ledger.id = decodeURIComponent(this.commonSer.GetParam('lid') + '');
      } else {
        this.ledger.id = localStorage.getItem('ledgerid');
      }
    }
  
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [
      {
        LedgerId: this.ledger.id ? this.ledger.id : this.ledger.ledgerid,
        // fromDT: new Date(this.Date[0].fdt).customFormat('#DD#-#MMM#-#YY#'),
        fromDT: new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#'),
        toDT: new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#'),
        //toDT: new Date(this.Date[0].tdt).customFormat('#DD#-#MMM#-#YY#')
      },
    ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'get',
        moduleID: 2,
        data: JSON.stringify(data),
      },
    ];

    this.SpinnerLoader.show();
    this.apiService.getData(
      myParams,
      this.successResp.bind(this),
      this.failureResp.bind(this)
    );

    let tmpData = this.apiService.getCookie('Ledger');

    if (tmpData) {
      this.ledgers = JSON.parse(tmpData);
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    } else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.data = reponseData;
          if (this.data.Table[0].ErrCode == '1') {
            alert(this.data.Table[0].ErrMsg);
            return;
          }
          this.voucher = this.data.Table1;
          this.voucher.forEach((e: any) => {
            e.date = new Date(e.EffectiveDate);
            e.newCloBal = String(e.CloBal).indexOf(' Cr') > -1 ? '-' + e.CloBal : e.CloBal;
            e.newCloBal = String(e.newCloBal).replaceAll(' Cr', '').replaceAll(' Db', '');

            let tmpUser = this.userList.filter(
              (x: any) => x.UserID == e.CreatedUserID
            );
            if (tmpUser.length > 0) {
              e.user = tmpUser[0].Name;
            }
          });
          this.dataSource.data = this.voucher;
          this.exportToExcel = this.voucher
          this.opbal = this.voucher[0].CloBal;
          let opbal1 = this.opbal.split('.', 3);
          this.newopbal = opbal1[1].split(' ', 3);

          if (this.newopbal[1] == 'Cr') {
            this.newopbal = -Number(opbal1[0].replace(/,/g, ''));
          } else {
            this.newopbal = Number(opbal1[0].replace(/,/g, ''));
          }
          // this.newopbal = this.opbal.split(".", 3)

          this.colbal = this.voucher[this.voucher.length - 1].CloBal;
          let colbal1 = this.colbal.split('.', 3);
          this.newcolbal = colbal1[1].split(' ', 3);

          if (this.newcolbal[1] == 'Cr') {
            this.newcolbal = -Number(colbal1[0].replace(/,/g, ''));
          } else {
            this.newcolbal = Number(colbal1[0].replace(/,/g, ''));
          }
          
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.matSort;
          // this.dataSource.filterPredicate = this.createFilter();
          // console.log('voucher', this.voucher)
          // this.voucher.forEach((element: any) => {
          //   element.isShow = false;
          // });
          // console.log('Vouchers', this.voucher);
        }
      }
    }
  }

  printVoucher() {
    this.appService.ledgerRecordPrintData(this.voucher);

    let Lid: number = this.ledger.id ? this.ledger.id : this.ledger.LedgerID;
    window.open(
      'LedgerRecordPrint?LID=' +
      Lid +
      '&fdt=' +
      new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#') +
      '&tdt=' +
      new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#') +
      '&lname=' +
      encodeURIComponent(this.ledgername),
      '_blank',
      'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No'
    );
  }

  // exportToExcel() {
  //   const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(this.dataSource.data);
  //   const wb: xlsx.WorkBook = xlsx.utils.book_new();
  //   xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
  //   xlsx.writeFile(wb, 'Ledger Record - ' + this.ledgername + '.xlsx');
  // }
  updateDisplayedColumns(ledgerType: number) {
    const baseColumns = ['date', 'VoucherNum', 'MainLedger', 'DbAmt', 'CrAmt', 'CloBal', 'Notes', 'Print'];
    this.displayedColumns = baseColumns;
  }

  ledgerchange(name: any) { 
    this.ledger.name = name;
    let ledger = this.ledgerList.find((l: any) => l.LedgerName == this.ledger.name);
    this.ledgerId = ledger.LedgerID;
    this.ledgerType = ledger.LedgerType;
    this.updateDisplayedColumns(this.ledgerType);
    this.getData();
  }

  editVoucher(content: any, row: any) {
    this.modalReference = this.modalService.open(VoucherEntryComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'my-class',
      backdrop: 'static',
      keyboard: false,
    });
    this.modalReference.componentInstance.voucherID = row.VoucherID;
    this.modalReference.componentInstance.mdlRefHide = this.modalReference;
    this.modalReference.result.then(
      (result: any) => {
        if (result == true) {
          this.templedgerList = this.apiService.getCookie('Ledger');
          if(this.templedgerList){
            this.ledgerList = JSON.parse(this.templedgerList);
          }
          else {
            this.ledgerList = [];
          }
          this.getData();
          this.appService.updateVoucherEntered(1);
        }
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openEditWindowVoucher(voucherID: any){
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
    // window.open(urlCheck, '_blank', 'height = 600, width = 1250');
    var win: any = window.open(urlCheck + '?voucherID=' + voucherID, '_blank', 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.getData();
          this.appService.updateVoucherEntered(1);
          win.close();
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
 }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {      
      this.dataSource.paginator.firstPage();
    }
  }

  open(content: any) {
    this.modalReference = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'my-class',
      backdrop: 'static',
      keyboard: false,
    });
    this.modalReference.result.then(
      (result: any) => {
        this.closeResult = `Closed with: ${result}`;
        this.getData();
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.getData();
      }
    );
    //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    //       this.closeResult = `Closed with: ${result}`;
    //   }, (reason) => {
    //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
  }

  openNewWindowVoucher($event: any){
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
   
    var win: any = window.open(urlCheck, '_blank', 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.changingValue.next($event);
          this.changingHeadValue.next($event);
          win.close();
          this.templedgerList = this.apiService.getCookie('Ledger');
          if(this.templedgerList){
            this.ledgerList = JSON.parse(this.templedgerList);
          }
          else {
            this.ledgerList = [];
          }
          this.getData();

          if(win.updateData){
            if(win.updateData.length > 0){
              if(win.updateData[0].isUpdateInvoice == true){
                this.relID = win.updateData[0].relID;
                if(this.relID > 0){
                  this.invInvoiceStatusUpdate();
                }
              }
            }
          }
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
    //window.open("/voucher", '_blank', 'height = 600, width = 1250');
  }

  refresh() {
    this.getData();
  }

  fn_ChangeDate() {
    // Here Set Accounting Year of Selected Date
    var Date2 = new Date(this.fromDate);
    var Date1 = new Date(this.toDate);
    var acctStartDT = new Date(this.acctStartDT);
    let CurrentDate = new Date();

    if (Date1 < acctStartDT) {
      alert(
        'Please select date after ' +
        this.acctStartDT.customFormat('#DD#-#MMM#-#YY#')
      );
      this.fn_Set_FinancialYear(CurrentDate);
      return;
    }

    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1;
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1;
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      Date2 = new Date(Year + '/04/01');
      //this.fromDate = new Date(Year + "/04/01");
      //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
    } else if (IsPrevios == 0) {
      Date2 = new Date(Date1.getFullYear() + '/04/01');
      //this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      // $scope.ToDate = new Date(Year + "/03/31");
    }

    //fn_HeadSummary();

    //fn_Set_FinancialYear($scope.ToDate);
    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    // let accountDate: Array<any> = [
    //   {
    //     fdt: new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#'),
    //     tdt: new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#'),
    //     selectedFy: this.selectedFY,
    //   },
    // ];
    // this.apiService.setCookie('AccountsDates', JSON.stringify(accountDate));
    this.getData();
  }

  fn_changeFinancialYear($event: any) {
    if (this.selectedFY != 'Other') {
      // let selectedYear = String(this.selectedFY).split('-');
      // let accountDate: Array<any> = [
      //   {
      //     fdt: '1-Apr-' + selectedYear[0],
      //     tdt: '31-Mar-' + selectedYear[1],
      //     selectedFy: this.selectedFY,
      //   },
      // ];
      // this.apiService.setCookie('AccountsDates', JSON.stringify(accountDate));

      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    } else {
      this.getData();
    }
  }

  public closeModal($event: any) {
    this.modalReference.close();
    if ($event) {
      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    }
  }

  printLedger(id: number) {
    var VID = id;
    window.open(
      'voucherPrint?VID=' + VID,
      '_blank',
      'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No'
    );
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  opennote(content: any, row: any) {
    this.modalReference = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'class-note',
      backdrop: 'static',
      keyboard: false,
    });
    this.vouchernum = row.VoucherNum;
    this.DateNote = new Date(row.EffectiveDate).customFormat('#DD#-#MMM#-#YY#');
    this.vouchernote = row.Notes;
    this.modalReference.result.then(
      (result: any) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    //       this.closeResult = `Closed with: ${result}`;
    //   }, (reason) => {
    //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
  }

  exportToExcelActivities() {
    var html = "";
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Ledger Record</th>"
    html += "</table></tr>";

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    this.toDate = (this.toDate._d ? this.toDate._d : this.toDate);
    this.fromDate = (this.fromDate._d ? this.fromDate._d : this.fromDate);
    let date: any = this.fromDate.customFormat("#DD#-#MMM#-#YYYY#") + " to " + this.toDate.customFormat("#DD#-#MMM#-#YYYY#") 
    let totalDb = 0, totalCr = 0;

    html += "<p><b>Ledger : </b>" + this.ledgername + "<b>, Period : </b>"+ (this.selectedFY != 'Other' ?  this.selectedFY  : date) + "</p>"
    // Empty row
   
    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Date</th>";
    strHeader += "<th style='text-align: left;'>Voucher No.</th>";
    strHeader += "<th style='text-align: left;'>Ledger</th>";
    strHeader += "<th style='text-align: right;'>Debit</th>";
    strHeader += "<th style='text-align: right;'>Credit</th>";
    strHeader += "<th style='text-align: right;'>Balance</th>";
    strHeader += "<th style='text-align: left;'>Notes</th>";

    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      item.date = (item.date == null) ? '-' : new Date(item.date).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.date + "</td>";
      body += "<td style='text-align: left;'>" + (item.VoucherNum ? item.VoucherNum : '-') + "</td>";
      body += "<td style='text-align: left;'>" + (item.MainLedger ? item.MainLedger : '-') + "</td>";

      let dbAmt = String(Number(String(item.NewDbAmt).replaceAll(",", "")).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      let crAmt = String(Number(String(item.NewCrAmt).replaceAll(",", "")).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + dbAmt + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + crAmt + "</td>";
      var newBal = ''
      if(Number(String(item.newCloBal).replaceAll(",","")) < 0){
        newBal = 'Cr'
      }
      else{
        newBal = 'Db'
      }
      // let clobal = String(Number(item.newCloBal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "")
      let clobal = String(Number(String(item.newCloBal).replaceAll(",", "")).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + clobal + " " + newBal +"</td>";
      // Build combined notes: <notes>-<paymentmode>-<paymentref>
      let combinedNotes = item.Notes ? item.Notes : '';
      if (item.PaymentMode && item.PaymentMode != '0') {
        combinedNotes += '-' + item.PaymentMode;
      }
      if (item.PaymentRef) {
        combinedNotes += '-' + item.PaymentRef;
      }
      body += "<td style='text-align: left;'>" + (combinedNotes || '-') + "</td>";
  
      body += "</tr>";
    
      // Calculate Total Debit and Credit
      totalDb += Number(String(item.NewDbAmt).replaceAll(",", ""));
      totalCr += Number(String(item.NewCrAmt).replaceAll(",", ""));
    })

    body += "<tr></tr>";
    body += "<tr>";
    body += "<td style='text-align: left; font-weight: bold;'>Grand Total</td>";
    body += "<td></td><td></td><td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalDb.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + "</td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalCr.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + "</td>";
    body += "<td></td>"; // Balance column
    body += "<td></td>"; // Notes column
    body += "</tr>";
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', 'Ledger Record - ' + this.ledgername );
  }

  invInvoiceStatusUpdate(){
    this.modalReference = this.modalService.open(InvoiceStatusComponent,{ ariaLabelledBy: 'modal-basic-title', windowClass: '', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.relID = this.relID;
    this.modalReference.result.then((result: any) => {
      // if (result.action == 'Done') {
      //   window.location.reload();
      // }
    });
  }

  editPeriod() {
    this.show.edit = false;
    this.show.save = true;
    this.disable.fromInput = false;
    this.disable.toInput = false;
  }

  changePeriod() {
    this.fn_ChangeDate();
    this.show.edit = true;
    this.show.save = false;
    this.disable.fromInput = true;
    this.disable.toInput = true;
  }

  openLdgrRcrdPrntPrefs() {
    this.getConfigData();
    this.modalService.open(this.ldgrRcrdPrntPrefsMdl, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: '',
      keyboard: false,});
  }

  // getConfigData() - get ERP Config Data
  getConfigData () {
    var erpConfigCookie = this.apiService.getCookie('ERP_Cfg');
    if (erpConfigCookie) {
      this.erpConfig = JSON.parse(erpConfigCookie);
      if (this.erpConfig && this.erpConfig.length > 0) {
        let ldgrRecordPrintPrefs = this.erpConfig[0]?.LdgrRcrdPrtPrefs ? this.erpConfig[0]?.LdgrRcrdPrtPrefs : '[]';
        if (ldgrRecordPrintPrefs) {
          ldgrRecordPrintPrefs = JSON.parse(ldgrRecordPrintPrefs);
          this.ldgrRcrdPrtPrefs.isNarrrationEnbl = ldgrRecordPrintPrefs[0]?.Nrtn == 1 ? true : false;
          this.ldgrRcrdPrtPrefs.isCommonNotesEnbl = ldgrRecordPrintPrefs[0]?.CmnNotes == 1 ? true : false;
        }
      }
    }
  }

  saveLdgrRcrdPrntPrefs() {
    let paramData = [{
      'ChangeType': 'LDGRRCRD',
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod': 1,
      'PrdRejnReasons': '',
      'HSNSAC':'',
      'ldgrRcrdPrtPrefs': JSON.stringify([{
        "Nrtn": this.ldgrRcrdPrtPrefs.isNarrrationEnbl ? 1 : 0,
        "CmnNotes": this.ldgrRcrdPrtPrefs.isCommonNotesEnbl ? 1 : 0,
      }])
    }];

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(paramData)
    }];
    this.SpinnerLoader.show();
    this.apiService.sendChange(myParams, this.successSetConfigResp.bind(this), this.failureSetConfigResp.bind(this));
  }
      
  //successResp - success  get handler
  successSetConfigResp(res: any) {
    this.SpinnerLoader.hide();  
    if (res.error) {
    }
    else {
        if (res) {
          var responseData = JSON.parse(res.updatePackage);
          if (responseData.Table[0].ErrCode != '-1') {
            this.apiService.successAlert(responseData.Table[0].ErrMsg);
            return;
          }

          // Save the response (Latest update package for ERP) to localStorage
          for (let key in responseData) {
            const arr = responseData[key];

            if (Array.isArray(arr) && arr.length > 0 && arr[0].Tbl) {
                const tblKey = arr[0]?.Tbl;
                const value = JSON.stringify(arr); // Store the full object
                if (tblKey) {
                  localStorage.setItem(tblKey, value);
                }
            }
        }

          this.closePrintSettings();
        }
    }
  }

  //failureResp - failure handler
  failureSetConfigResp(res: any) {
    this.SpinnerLoader.hide();
    if (!res.error) {
      this.apiService.successAlert(res.message);
    }
  }

  closePrintSettings() {
    this.modalService.dismissAll();
  }
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh,
      h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + '').slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? '0' + M : M;
  MMM = (MMMM = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? '0' + D : D;
  DDD = (DDDD = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ][this.getDay()]).substring(0, 3);
  th = D >= 10 && D <= 20 ? 'th' : (dMod = D % 10) == 1 ? 'st' : dMod == 2 ? 'nd' : dMod == 3 ? 'rd' : 'th';
  
  formatString = formatString
    .replace('#YYYY#', YYYY)
    .replace('#YY#', YY)
    .replace('#MMMM#', MMMM)
    .replace('#MMM#', MMM)
    .replace('#MM#', MM)
    .replace('#M#', M)
    .replace('#DDDD#', DDDD)
    .replace('#DDD#', DDD)
    .replace('#DD#', DD)
    .replace('#D#', D)
    .replace('#th#', th);
  h = hhh = this.getHours();
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? '0' + h : h;
  hhhh = h < 10 ? '0' + hhh : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? '0' + m : m;
  ss = (s = this.getSeconds()) < 10 ? '0' + s : s;
  return formatString
    .replace('#hhhh#', hhhh)
    .replace('#hhh#', hhh)
    .replace('#hh#', hh)
    .replace('#h#', h)
    .replace('#mm#', mm)
    .replace('#m#', m)
    .replace('#ss#', ss)
    .replace('#s#', s)
    .replace('#ampm#', ampm)
    .replace('#AMPM#', AMPM);
};
